import { render } from "./InvoiceMonitor.vue?vue&type=template&id=28544470&scoped=true"
import script from "./InvoiceMonitor.vue?vue&type=script&lang=js"
export * from "./InvoiceMonitor.vue?vue&type=script&lang=js"

import "./InvoiceMonitor.vue?vue&type=style&index=0&id=28544470&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28544470"]])

export default __exports__